import styled from 'styled-components';

interface ImageMenuWrapperProps {
  singleItem?: boolean;
}

interface ButtonWrapperProps {
  unselected?: boolean;
}

export const ImageMenuWrapper = styled.div<ImageMenuWrapperProps>`
  display: flex;
  justify-content: ${(props) => (props.singleItem ? 'start' : 'space-evenly')};
`;

export const ButtonWrapper = styled.div<ButtonWrapperProps>`
  display: flex;
  flex-direction: column;
  align-items: center;

  div:nth-of-type(2) {
    margin-left: -5px;
    margin-top: -10px;
  }

  ${(props) => (props.unselected ? '-webkit-filter: grayscale(100%)' : '')};
  ${(props) => (props.unselected ? '-moz-filter: grayscale(100%)' : '')};
  ${(props) => (props.unselected ? '-ms-filter: grayscale(100%)' : '')};
  ${(props) => (props.unselected ? '-o-filter: grayscale(100%)' : '')};
  ${(props) => (props.unselected ? 'filter: grayscale(100%)' : '')};
  ${(props) => (props.unselected ? 'filter: gray' : '')};
  ${(props) => (props.unselected ? 'opacity: 0.75' : '')};
`;

export const OptionalExtraImage = styled.img`
  height: 2.5rem;
  width: 3.5rem;
  pointer-events: none;
`;

export const OptionInformationWrapper = styled.div`
  margin-top: 0.5em;
`;
